import api from '@/api'

export default {
  namespaced: true,
  state: {
    items: [],
    fetching: false
  },
  actions: {
    async fetchSizes ({ state, commit, getters }) {
      commit('fetching')

      const sizes = await api.netshoes.getSizes()

      commit('setFetchData', sizes)
    }
  },
  getters: {
    getSizes: state => () => state.items
  },
  mutations: {
    setFetchData (state, items) {
      state.items = items
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sizes.js